<style>
  .centralize {
    width: 100%;
    position: relative;
    height: 100%;
  }

  .spinner-border {
      display: block;
      position: fixed;
      top: calc(50% - (58px / 2));  
      right: calc(50% - (58px / 2));
      color: rgba(0, 0, 0, 0.4);
  }

  #backdrop {
    position:absolute;
    top:0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgb(0,0,0,0.2);
  }
</style>

<template></template>

<script>
    export default {
        props: {
            isLoading: {
                type: Boolean,
                default: true,
                required: true
            }
        },

        watch: {
            isLoading: {
                handler(newIsLoading) {
                    console.log({newIsLoading});
                    const backdropDiv = document.querySelector('#backdrop');
                    if (backdropDiv) {
                        backdropDiv.style.display = newIsLoading ? 'block' : 'none';
                        document.querySelector('body').style.overflow =  newIsLoading ? 'hidden' : 'auto';
                    }
                }
            },
            immediate: true
        },

        beforeMount() {
            const backdropDiv = document.createElement('div');
            backdropDiv.id = 'backdrop';
            backdropDiv.style.display = this.isLoading ? 'block' : 'none'; // Equivalent to v-if="!isLoading"
            document.querySelector('body').style.overflow =  this.isLoading ? 'hidden' : 'auto';

            // Create the loading div element with the "text-center loading" classes
            const loadingDiv = document.createElement('div');
            loadingDiv.className = 'text-center loading';

            // Create the spinner div element with the "spinner-border" class
            const spinnerDiv = document.createElement('div');
            spinnerDiv.className = 'spinner-border';
            spinnerDiv.setAttribute('role', 'status');

            // Create the span element with the "sr-only" class and text content
            const spanElement = document.createElement('span');
            spanElement.className = 'sr-only';
            spanElement.textContent = 'Carregando'; // You can replace this with your dynamic text

            // Append the elements to build the structure
            spinnerDiv.appendChild(spanElement);
            loadingDiv.appendChild(spinnerDiv);
            backdropDiv.appendChild(loadingDiv);

            // Append the backdropDiv to the document body or another parent element
            document.body.appendChild(backdropDiv);
        },

        
    }
</script>